import PageTransitionLoading from "@/components/PageTransitionLoading";
import { useDeviceInfoQuery, usePreventContextMenu } from "@/hooks";
import Footer from "@/layouts/footer";
import Header from "@/layouts/Header";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Layout(_ref) {
  var _router$asPath;

  var children = _ref.children,
      noHeader = _ref.noHeader,
      noTransition = _ref.noTransition;
  usePreventContextMenu();
  var router = useRouter();

  var _useDeviceInfoQuery = useDeviceInfoQuery(),
      _useDeviceInfoQuery$d = _useDeviceInfoQuery.data;

  _useDeviceInfoQuery$d = _useDeviceInfoQuery$d === void 0 ? {} : _useDeviceInfoQuery$d;
  var deviceInfo = _useDeviceInfoQuery$d.deviceInfo;
  var isTvApp = router === null || router === void 0 ? void 0 : (_router$asPath = router.asPath) === null || _router$asPath === void 0 ? void 0 : _router$asPath.includes("/tvapp/static");
  var visible = !(deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isWebView) && !isTvApp;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PageTransitionLoading, {}), visible && /*#__PURE__*/_jsx(Header, {
      noHeader: noHeader,
      noTransition: noTransition
    }), /*#__PURE__*/_jsx("main", {
      id: "main",
      tabIndex: -1,
      children: children
    }), visible && /*#__PURE__*/_jsx(Footer, {})]
  });
}